import PropTypes from 'prop-types';
import React, {Fragment, forwardRef, memo} from 'react';
import {CircularProgress, Fade, Typography, styled} from '@mui/material';

const DEFAULT_PAPER_COLOR = 'rgba(255, 255, 255, 0.8)';

// Styles
const Cover = styled('div')(({color}) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: color || 'none',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

const WithCover = forwardRef(({cover, children, color}, ref) => {
  if (cover) {
    return (
      <Cover ref={ref} color={color}>
        {children}
      </Cover>
    );
  } else {
    return <Fragment>{children}</Fragment>;
  }
});

WithCover.propTypes = {
  cover: PropTypes.bool,
  children: PropTypes.array,
  color: PropTypes.string,
};

const Loading = ({
  cover = false,
  loading = false,
  coverColor = DEFAULT_PAPER_COLOR,
  Component = CircularProgress,
  text = null,
  ...props
}) => (
  <Fade in={loading} mountOnEnter unmountOnExit>
    <WithCover cover={cover} color={coverColor}>
      <Component {...props} />
      {text && <Typography>{text}</Typography>}
    </WithCover>
  </Fade>
);

Loading.propTypes = {
  cover: PropTypes.bool,
  loading: PropTypes.bool,
  coverColor: PropTypes.string,
  Component: PropTypes.any,
  text: PropTypes.string,
};

export default memo(Loading);
